import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

interface SvgIconProps {
  svgUrl: string;
  color: string;
  size: number;
}

/**
 * Fetches an external SVG and renders it inline, allowing color styling.
 * The SVG will be colored using the `color` prop.
 */
const SvgIcon: React.FC<SvgIconProps> = ({ svgUrl, color, size }) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      const response = await fetch(svgUrl);
      const text = await response.text();
      setSvgContent(text);
    };

    fetchSvg();
  }, [svgUrl]);

  if (!svgContent) {
    return;
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color,
        '& svg': {
          width: '100%',
          height: '100%',
          fill: 'currentColor',
          '& path': { fill: 'currentColor' },
          '& circle': { fill: 'currentColor' },
          '& rect': { fill: 'currentColor' },
          '& polygon': { fill: 'currentColor' },
        },
      }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgIcon;
